<template>
  <el-dialog
    v-drag:common
    title="总投资"
    :visible.sync="modal"
    class="solid-table total-invest-dialog"
    width="80%"
    append-to-body
  >
    <el-table :data="data" :span-method="spanMethod" :show-header="false">
      <el-table-column
        v-for="(col, i) in columns"
        :key="i"
        :prop="col.prop"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="['name', 'unit'].includes(col.prop)">
            {{ scope.row[col.prop] }}
          </div>
          <el-select
            v-else-if="scope.$index === 0"
            :value="scope.row[col.prop]"
            @change="changeTurbine($event, scope.column.property)"
          >
            <el-option
              v-for="item in turbineNameList"
              :key="item.dataId"
              :label="item.turbineTypeName"
              :value="item.dataId.toString()"
            >
            </el-option>
            <el-option key="-1" label="请选择" value="-1"> </el-option>
          </el-select>
          <el-input
            v-else
            v-model="scope.row[col.prop]"
            @input="changeRowValue($event, col.prop, scope.$index, scope.row)"
          ></el-input>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="reset">重置</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import findIndex from 'lodash/findIndex';

function getColValue(rows, col, excludes, turbineMap) {
  const { prop } = col;
  let res;
  rows.forEach((row, i) => {
    if (excludes.includes(row.key)) return;
    if (['name', 'unit'].includes(prop)) return;
    if (!isNil(row[prop])) {
      if (!res) res = {};
      if (i === 0) {
        res.dataId = row[prop] || 0;
        res.turbineTypeId = turbineMap[row[prop]]?.turbineTypeId;
        res.turbineTypeName = turbineMap[row[prop]]?.turbineTypeName;
      } else {
        res[row.key] = row[prop];
      }
    }
  });
  return res;
}

// 总投资
export default {
  props: {
    economicId: {
      type: Number,
      default: 0
    },
    planId: {
      type: Number,
      default: 0
    },
    formData: [Object],
    visible: Boolean
  },
  data() {
    return {
      modal: false,
      rows: [
        {
          name: '轮毂高度',
          key: 'hubHeight',
          unit: 'm'
        },
        {
          name: '额定功率',
          key: 'ratedPower',
          unit: '万kW'
        },
        {
          name: '台数',
          key: 'count',
          unit: ''
        },
        {
          name: '容量',
          key: 'cap',
          unit: '万kW'
        },
        {
          name: '主机单价',
          key: 'hostCost',
          unit: '元/kW'
        },
        {
          name: '基础价格',
          key: 'baseCost',
          unit: '万元/座'
        },
        {
          name: '基础折算单价',
          key: 'baseConversionCost',
          unit: '元/kW'
        },
        {
          name: '吊装费用',
          key: 'hoistingCost',
          unit: '万元/台'
        },
        {
          name: '吊装折算单价',
          key: 'hoistingConversionCost',
          unit: '元/kW'
        },
        {
          name: '塔筒价格',
          key: 'tubeCost',
          unit: '万元/t'
        },
        {
          name: '塔筒重量',
          key: 'tubeWeight',
          unit: 't'
        },
        {
          name: '塔筒总价',
          key: 'tubeTotalCost',
          unit: '万元'
        },
        {
          name: '塔筒折算单价',
          key: 'tubeConversionCost',
          unit: '元/kW'
        },
        {
          name: '箱变',
          key: 'boxTransformer',
          unit: '万元/个'
        },
        {
          name: '箱变折算单价',
          key: 'boxConversionCost',
          unit: '元/kW'
        },
        {
          name: '征地费用指标',
          key: 'landAcquisitionTarget',
          unit: '万元/台'
        },
        {
          name: '征地折算单价',
          key: 'landAcquisitionConversionCost',
          unit: '元/kW'
        },
        {
          name: '发电小时',
          key: 'hours',
          unit: 'h'
        },
        {
          name: '上述主要差别项单价',
          key: 'differenceCost',
          unit: '元/kW'
        },
        {
          name: '其他费用单价',
          key: 'otherCost',
          unit: '元/kW'
        },
        {
          name: '单位静态投资',
          key: 'unitStaticInvestment',
          unit: '元/kW'
        },
        {
          name: '静态投资',
          key: 'staticTotalInvestment',
          unit: '万元'
        }
        // {
        //   name: '可抵扣税金',
        //   key: 'deductibleTax',
        //   unit: '万元'
        // },
        // {
        //   name: '电价',
        //   key: 'priceWith',
        //   unit: '元/kWh'
        // }
      ],
      effects: {
        baseConversionCost: {
          dependances: ['cap', 'baseCost'],
          runEffect({ current }) {
            if (!current.cap) return 0;
            if (!current.baseCost) return 0;
            return current.baseCost / current.cap;
          }
        },
        hoistingConversionCost: {
          dependances: ['cap', 'hoistingCost'],
          runEffect({ current }) {
            if (!current.cap) return 0;
            if (!current.hoistingCost) return 0;
            return current.hoistingCost / current.cap;
          }
        },
        tubeConversionCost: {
          dependances: ['cap', 'tubeTotalCost'],
          runEffect({ current }) {
            if (!current.cap) return 0;
            if (!current.tubeTotalCost) return 0;
            return current.tubeTotalCost / current.cap;
          }
        },
        boxConversionCost: {
          dependances: ['cap', 'boxTransformer'],
          runEffect({ current }) {
            if (!current.cap) return 0;
            if (!current.boxTransformer) return 0;
            return current.boxTransformer / current.cap;
          }
        },
        staticTotalInvestment: {
          dependances: ['cap', 'unitStaticInvestment'],
          runEffect({ all }) {
            let result = 0;
            Object.keys(all).forEach(key => {
              const current = all[key];
              if (current.cap && current.unitStaticInvestment) {
                result += current.cap * current.unitStaticInvestment;
              }
            });
            return result;
          }
        }
      },
      dataOfEconomicId: '',
      data: [],
      columns: [],
      // keys: ['deductibleTax', 'priceWith'],
      keys: [],
      readonlyKeys: ['staticTotalInvestment'],
      turbineNameList: []
    };
  },
  watch: {
    modal(val) {
      this.$emit('update:visible', val);
      this.asyncFormData();
    },
    visible(val) {
      this.modal = val;
    },
    economicId() {
      this.changeEconomicId();
    },
    formData() {
      if (!this.visible) return;
      this.asyncFormData();
    }
  },
  async mounted() {
    this.changeEconomicId = debounce(this.changeEconomic, 1000);
    await this.load();
    this.computeStaticTotalInvestment();
  },
  methods: {
    changeEconomic() {
      if (this.economicId !== this.dataOfEconomicId) {
        this.load();
      }
    },
    computeStaticTotalInvestment() {
      const context = this.getContext();
      const target = this.data.find(
        item => item.key === 'staticTotalInvestment'
      );
      target[0] = this.effects.staticTotalInvestment.runEffect(context);
    },
    async changeTurbine(value, prop) {
      if (value === '-1') {
        this.data.forEach(row => {
          row[prop] = '';
        });
        this.computeStaticTotalInvestment();
        return;
      }
      this.data[0][prop] = value.toString();
      const res = await this.$fetch('/windfarm/economic/getInvestTurbineList', {
        params: {
          dataId: value
        },
        showLoading: true,
        showError: true
      });
      this.data.forEach((row, i) => {
        if (i === 0) return;
        if (
          res.data?.investTurbineInfo &&
          !isNil(res.data?.investTurbineInfo[row.key])
        ) {
          row[prop] = res.data.investTurbineInfo[row.key];
        }
      });
      const index =
        findIndex(this.rows, row => row.key === 'unitStaticInvestment') + 1;
      this.changeRowValue(
        res.data.investTurbineInfo.unitStaticInvestment,
        0,
        index
      );
    },
    asyncFormData() {
      if (isEmpty(this.data)) return;
      this.keys.forEach(key => {
        const row = this.data.find(item => item.key === key);
        if (row) {
          row[0] = this.formData[key];
          row[1] = this.formData[key];
          row[2] = this.formData[key];
          row[3] = this.formData[key];
          row[4] = this.formData[key];
        }
      });
    },
    save() {
      this.visible = false;
      const excludeKeys = [...this.keys, ...this.readonlyKeys];
      const list = this.columns.reduce((acc, col) => {
        const colVal = getColValue(
          this.data,
          col,
          excludeKeys,
          this.turbineMap
        );
        if (colVal) {
          acc.push(colVal);
        }
        return acc;
      }, []);
      //console.log('changeInvestDetail', list);
      this.$emit('changeInvestDetail', list);
      // const staticTotalInvestment = this.data.find(
      //   row => row.key === 'staticTotalInvestment'
      // );
      // this.$emit('changeStaticTotalInvestment', staticTotalInvestment[0]);
    },
    reset() {
      this.data = cloneDeep(this.defaultData);
    },
    async load() {
      this.dataOfEconomicId = this.economicId;
      const listRes = await this.$fetch(
        '/windfarm/economic/getTurbineTypeList',
        { showError: true }
      );
      this.turbineMap = listRes.data.turbineTypeList.reduce((acc, item) => {
        acc[item.dataId] = item;
        return acc;
      }, {});
      this.turbineNameList = listRes.data.turbineTypeList;
      this.columns = [1, 1, 1, 1, 1].map((c, i) => {
        const item = !isEmpty(this.formData.totaInvestDetailList)
          ? this.formData.totaInvestDetailList[i]
          : {};
        return {
          prop: i.toString(),
          label: item?.turbineTypeName?.toString(),
          value: item?.dataId?.toString()
        };
      });
      this.columns.unshift(
        ...[
          {
            label: '机型',
            prop: 'name'
          },
          {
            label: '单位',
            prop: 'unit'
          }
        ]
      );
      const getRow = (list, row) => {
        return this.columns.reduce(
          (acc, col) => {
            if (col.prop === 'name') {
              acc.name = row.name;
            } else if (col.prop === 'unit') {
              acc.unit = row.unit;
            } else {
              if (this.keys.includes(row.key)) {
                acc[col.prop] = this.formData[row.key];
              } else {
                acc[col.prop] = get(list, `${col.prop}.${row.key}`);
              }
            }
            return acc;
          },
          { key: row.key }
        );
      };
      const tableData = this.rows.map(row =>
        getRow(this.formData.totaInvestDetailList || {}, row)
      );
      tableData.unshift(
        this.columns.reduce((acc, col) => {
          if (col.prop === 'name') {
            acc.name = '机型';
          } else if (col.prop === 'unit') {
            acc.unit = '单位';
          } else {
            acc[col.prop] = col.value;
          }
          return acc;
        }, {})
      );
      this.data = tableData;
      this.defaultData = cloneDeep(tableData);
    },
    spanMethod({ row, columnIndex }) {
      const keys = [...this.keys, ...this.readonlyKeys];
      if (keys.indexOf(row.key) !== -1) {
        if (columnIndex === 2) {
          return [1, this.columns.length];
        } else if (columnIndex > 2) {
          return [0, 0];
        }
      }
    },
    getContext(prop) {
      const current = {};
      const all = { 0: {}, 1: {}, 2: {}, 3: {}, 4: {} };
      this.data.forEach(item => {
        if (item[prop]) {
          current[item.key] = item[prop];
        }
        all[0][item.key] = item[0];
        all[1][item.key] = item[1];
        all[2][item.key] = item[2];
        all[3][item.key] = item[3];
        all[4][item.key] = item[4];
      });
      return { current, all };
    },
    changeRowValue(value, prop, index) {
      //console.log('change row', value, prop, index);
      const num = Number(value);
      if (window.isNaN(num)) {
        if (value) {
          const arr = value
            .replace(/[^\d.]/g, '')
            .split('.')
            .filter(str => str !== '');
          if (arr.length > 1) {
            arr.splice(1, 0, '.');
          }
          this.data[index][prop] = arr.join('');
        }
        return;
      }
      Object.keys(this.effects).forEach(key => {
        const effect = this.effects[key];
        if (!effect) return;
        if (effect.dependances.includes(this.data[index].key)) {
          const context = this.getContext(prop);
          const target = this.data.find(item => item.key === key);
          if (key === 'staticTotalInvestment') {
            target[0] = effect.runEffect(context);
          } else {
            target[prop] = effect.runEffect(context);
          }
        }
      });
    }
  }
};
</script>

<style lang="less">
.total-invest-dialog {
  .el-dialog__body {
    height: 500px;
    overflow: auto;
  }

  .el-input {
    .el-input__inner {
      text-align: center;
    }
  }
}
</style>
